import { HistoryStore } from '@iotv/datamodel-core';
import { isNonNaNNumber, SortOrder } from '@iotv/iotv-v3-types';
import { existsFilter } from '@iotv/core-services';
import { matchHistoryStore } from '@iotv/datamodel-core';
import { ObservationInputMetaKeys } from '../fns';
import dayjs from 'dayjs';
const debug = process.env.REACT_APP_DEBUG && false;
export const matchRawObservations = ({ recentStateHistory, observationHistory, }) => {
    if (recentStateHistory && observationHistory) {
        const observedHistory = observationHistory.observedHistory;
        if (!observedHistory.hasKey('fromTimestampMs') || !observedHistory.hasKey('toTimestampMs')) {
            console.info('matchRawObservations: observationHistory does not have required timestamp keys, cannot perform matching');
            return null;
        }
        const matchedHistoryStore = new HistoryStore(observedHistory);
        const firstTimestampMs = observedHistory.fromTimestampMs.reduce((min, t) => (isNonNaNNumber(t) && (min === null || t < min) ? t : min), null);
        const lastTimestampMs = observedHistory.toTimestampMs.reduce((max, t) => (isNonNaNNumber(t) && (max === null || t > max) ? t : max), null);
        if (isNonNaNNumber(firstTimestampMs) && isNonNaNNumber(lastTimestampMs)) {
            const observationHistorySnapshotArray = observedHistory.getStateSnapshotArray(SortOrder.ASCENDING);
            const observationHistoryLength = observationHistorySnapshotArray.length;
            if (observationHistoryLength > 0) {
                const firstObservationPeriodStart = observationHistorySnapshotArray.at(0)?.state.fromTimestampMs ?? 0;
                const lastObservationPeriodEnd = observationHistorySnapshotArray.at(observationHistoryLength - 1)?.state.toTimestampMs ?? 0;
                const recentStateHistorySlice = recentStateHistory.sliceByTimestamp([firstObservationPeriodStart, lastObservationPeriodEnd]);
                const observationKeys = observationHistory.observedHistory.keys().filter((k) => !ObservationInputMetaKeys.includes(k));
                const matchedKeys = recentStateHistory.keys().filter((k) => observationKeys.includes(k));
                matchedKeys.forEach((key) => {
                    const keyArray = recentStateHistorySlice[key];
                    if (keyArray instanceof Array) {
                        if (keyArray.length === 0) {
                            // this happens when the page is loaded directly and the top level call to useObjectHistory returns later than the update done based on the observation period
                            console.info(`WARN: matchRawObservations: key ${key} has no values in recentStateHistorySlice ( recentStateHistory has ${recentStateHistory.getLength()} readings and starts from ${dayjs(recentStateHistorySlice.timestamp[0])}, to ${dayjs(recentStateHistorySlice.timestamp[recentStateHistorySlice.timestamp.length - 1])}), will yield empty array for this key`, { recentStateHistory });
                        }
                        const readings = keyArray.map((value, i) => {
                            const timestamp = recentStateHistorySlice.timestamp[i];
                            if (isNonNaNNumber(timestamp) && isNonNaNNumber(value)) {
                                return { timestamp, value };
                            }
                            else {
                                return null;
                            }
                        })
                            .filter(existsFilter);
                        const params = {
                            key,
                            readings,
                        };
                        matchHistoryStore.call(matchedHistoryStore, params);
                    }
                });
            }
            else {
                console.info('matchRawObservations: observationHistory does not have any snapshots, cannot perform matching');
            }
        }
        else {
            console.info('matchRawObservations: observationHistory does not have valid first and last timestamps, cannot perform matching', { firstTimestampMs, lastTimestampMs });
        }
        return matchedHistoryStore;
    }
    else {
        return null;
    }
};
